// Comprehensive list of world countries with ISO 2-letter codes
export const WORLD_COUNTRIES = {
  AF: { code: 'AF', name: 'Afghanistan', flag: '🇦🇫' },
  AL: { code: 'AL', name: 'Albania', flag: '🇦🇱' },
  DZ: { code: 'DZ', name: 'Algeria', flag: '🇩🇿' },
  AD: { code: 'AD', name: 'Andorra', flag: '🇦🇩' },
  AO: { code: 'AO', name: 'Angola', flag: '🇦🇴' },
  AG: { code: 'AG', name: 'Antigua and Barbuda', flag: '🇦🇬' },
  AR: { code: 'AR', name: 'Argentina', flag: '🇦🇷' },
  AM: { code: 'AM', name: 'Armenia', flag: '🇦🇲' },
  AU: { code: 'AU', name: 'Australia', flag: '🇦🇺' },
  AT: { code: 'AT', name: 'Austria', flag: '🇦🇹' },
  AZ: { code: 'AZ', name: 'Azerbaijan', flag: '🇦🇿' },
  BS: { code: 'BS', name: 'Bahamas', flag: '🇧🇸' },
  BH: { code: 'BH', name: 'Bahrain', flag: '🇧🇭' },
  BD: { code: 'BD', name: 'Bangladesh', flag: '🇧🇩' },
  BB: { code: 'BB', name: 'Barbados', flag: '🇧🇧' },
  BY: { code: 'BY', name: 'Belarus', flag: '🇧🇾' },
  BE: { code: 'BE', name: 'Belgium', flag: '🇧🇪' },
  BZ: { code: 'BZ', name: 'Belize', flag: '🇧🇿' },
  BJ: { code: 'BJ', name: 'Benin', flag: '🇧🇯' },
  BT: { code: 'BT', name: 'Bhutan', flag: '🇧🇹' },
  BO: { code: 'BO', name: 'Bolivia', flag: '🇧🇴' },
  BA: { code: 'BA', name: 'Bosnia and Herzegovina', flag: '🇧🇦' },
  BW: { code: 'BW', name: 'Botswana', flag: '🇧🇼' },
  BR: { code: 'BR', name: 'Brazil', flag: '🇧🇷' },
  BN: { code: 'BN', name: 'Brunei', flag: '🇧🇳' },
  BG: { code: 'BG', name: 'Bulgaria', flag: '🇧🇬' },
  BF: { code: 'BF', name: 'Burkina Faso', flag: '🇧🇫' },
  BI: { code: 'BI', name: 'Burundi', flag: '🇧🇮' },
  CV: { code: 'CV', name: 'Cabo Verde', flag: '🇨🇻' },
  KH: { code: 'KH', name: 'Cambodia', flag: '🇰🇭' },
  CM: { code: 'CM', name: 'Cameroon', flag: '🇨🇲' },
  CA: { code: 'CA', name: 'Canada', flag: '🇨🇦' },
  CF: { code: 'CF', name: 'Central African Republic', flag: '🇨🇫' },
  TD: { code: 'TD', name: 'Chad', flag: '🇹🇩' },
  CL: { code: 'CL', name: 'Chile', flag: '🇨🇱' },
  CN: { code: 'CN', name: 'China', flag: '🇨🇳' },
  CO: { code: 'CO', name: 'Colombia', flag: '🇨🇴' },
  KM: { code: 'KM', name: 'Comoros', flag: '🇰🇲' },
  CG: { code: 'CG', name: 'Congo', flag: '🇨🇬' },
  CD: { code: 'CD', name: 'Congo (Democratic Republic)', flag: '🇨🇩' },
  CR: { code: 'CR', name: 'Costa Rica', flag: '🇨🇷' },
  CI: { code: 'CI', name: "Côte d'Ivoire", flag: '🇨🇮' },
  HR: { code: 'HR', name: 'Croatia', flag: '🇭🇷' },
  CU: { code: 'CU', name: 'Cuba', flag: '🇨🇺' },
  CY: { code: 'CY', name: 'Cyprus', flag: '🇨🇾' },
  CZ: { code: 'CZ', name: 'Czech Republic', flag: '🇨🇿' },
  DK: { code: 'DK', name: 'Denmark', flag: '🇩🇰' },
  DJ: { code: 'DJ', name: 'Djibouti', flag: '🇩🇯' },
  DM: { code: 'DM', name: 'Dominica', flag: '🇩🇲' },
  DO: { code: 'DO', name: 'Dominican Republic', flag: '🇩🇴' },
  EC: { code: 'EC', name: 'Ecuador', flag: '🇪🇨' },
  EG: { code: 'EG', name: 'Egypt', flag: '🇪🇬' },
  SV: { code: 'SV', name: 'El Salvador', flag: '🇸🇻' },
  GQ: { code: 'GQ', name: 'Equatorial Guinea', flag: '🇬🇶' },
  ER: { code: 'ER', name: 'Eritrea', flag: '🇪🇷' },
  EE: { code: 'EE', name: 'Estonia', flag: '🇪🇪' },
  SZ: { code: 'SZ', name: 'Eswatini', flag: '🇸🇿' },
  ET: { code: 'ET', name: 'Ethiopia', flag: '🇪🇹' },
  FJ: { code: 'FJ', name: 'Fiji', flag: '🇫🇯' },
  FI: { code: 'FI', name: 'Finland', flag: '🇫🇮' },
  FR: { code: 'FR', name: 'France', flag: '🇫🇷' },
  GA: { code: 'GA', name: 'Gabon', flag: '🇬🇦' },
  GM: { code: 'GM', name: 'Gambia', flag: '🇬🇲' },
  GE: { code: 'GE', name: 'Georgia', flag: '🇬🇪' },
  DE: { code: 'DE', name: 'Germany', flag: '🇩🇪' },
  GH: { code: 'GH', name: 'Ghana', flag: '🇬🇭' },
  GR: { code: 'GR', name: 'Greece', flag: '🇬🇷' },
  GD: { code: 'GD', name: 'Grenada', flag: '🇬🇩' },
  GT: { code: 'GT', name: 'Guatemala', flag: '🇬🇹' },
  GN: { code: 'GN', name: 'Guinea', flag: '🇬🇳' },
  GW: { code: 'GW', name: 'Guinea-Bissau', flag: '🇬🇼' },
  GY: { code: 'GY', name: 'Guyana', flag: '🇬🇾' },
  HT: { code: 'HT', name: 'Haiti', flag: '🇭🇹' },
  HN: { code: 'HN', name: 'Honduras', flag: '🇭🇳' },
  HU: { code: 'HU', name: 'Hungary', flag: '🇭🇺' },
  IS: { code: 'IS', name: 'Iceland', flag: '🇮🇸' },
  IN: { code: 'IN', name: 'India', flag: '🇮🇳' },
  ID: { code: 'ID', name: 'Indonesia', flag: '🇮🇩' },
  IR: { code: 'IR', name: 'Iran', flag: '🇮🇷' },
  IQ: { code: 'IQ', name: 'Iraq', flag: '🇮🇶' },
  IE: { code: 'IE', name: 'Ireland', flag: '🇮🇪' },
  IL: { code: 'IL', name: 'Israel', flag: '🇮🇱' },
  IT: { code: 'IT', name: 'Italy', flag: '🇮🇹' },
  JM: { code: 'JM', name: 'Jamaica', flag: '🇯🇲' },
  JP: { code: 'JP', name: 'Japan', flag: '🇯🇵' },
  JO: { code: 'JO', name: 'Jordan', flag: '🇯🇴' },
  KZ: { code: 'KZ', name: 'Kazakhstan', flag: '🇰🇿' },
  KE: { code: 'KE', name: 'Kenya', flag: '🇰🇪' },
  KI: { code: 'KI', name: 'Kiribati', flag: '🇰🇮' },
  KP: { code: 'KP', name: 'North Korea', flag: '🇰🇵' },
  KR: { code: 'KR', name: 'South Korea', flag: '🇰🇷' },
  KW: { code: 'KW', name: 'Kuwait', flag: '🇰🇼' },
  KG: { code: 'KG', name: 'Kyrgyzstan', flag: '🇰🇬' },
  LA: { code: 'LA', name: 'Laos', flag: '🇱🇦' },
  LV: { code: 'LV', name: 'Latvia', flag: '🇱🇻' },
  LB: { code: 'LB', name: 'Lebanon', flag: '🇱🇧' },
  LS: { code: 'LS', name: 'Lesotho', flag: '🇱🇸' },
  LR: { code: 'LR', name: 'Liberia', flag: '🇱🇷' },
  LY: { code: 'LY', name: 'Libya', flag: '🇱🇾' },
  LI: { code: 'LI', name: 'Liechtenstein', flag: '🇱🇮' },
  LT: { code: 'LT', name: 'Lithuania', flag: '🇱🇹' },
  LU: { code: 'LU', name: 'Luxembourg', flag: '🇱🇺' },
  MG: { code: 'MG', name: 'Madagascar', flag: '🇲🇬' },
  MW: { code: 'MW', name: 'Malawi', flag: '🇲🇼' },
  MY: { code: 'MY', name: 'Malaysia', flag: '🇲🇾' },
  MV: { code: 'MV', name: 'Maldives', flag: '🇲🇻' },
  ML: { code: 'ML', name: 'Mali', flag: '🇲🇱' },
  MT: { code: 'MT', name: 'Malta', flag: '🇲🇹' },
  MH: { code: 'MH', name: 'Marshall Islands', flag: '🇲🇭' },
  MR: { code: 'MR', name: 'Mauritania', flag: '🇲🇷' },
  MU: { code: 'MU', name: 'Mauritius', flag: '🇲🇺' },
  MX: { code: 'MX', name: 'Mexico', flag: '🇲🇽' },
  FM: { code: 'FM', name: 'Micronesia', flag: '🇫🇲' },
  MD: { code: 'MD', name: 'Moldova', flag: '🇲🇩' },
  MC: { code: 'MC', name: 'Monaco', flag: '🇲🇨' },
  MN: { code: 'MN', name: 'Mongolia', flag: '🇲🇳' },
  ME: { code: 'ME', name: 'Montenegro', flag: '🇲🇪' },
  MA: { code: 'MA', name: 'Morocco', flag: '🇲🇦' },
  MZ: { code: 'MZ', name: 'Mozambique', flag: '🇲🇿' },
  MM: { code: 'MM', name: 'Myanmar', flag: '🇲🇲' },
  NA: { code: 'NA', name: 'Namibia', flag: '🇳🇦' },
  NR: { code: 'NR', name: 'Nauru', flag: '🇳🇷' },
  NP: { code: 'NP', name: 'Nepal', flag: '🇳🇵' },
  NL: { code: 'NL', name: 'Netherlands', flag: '🇳🇱' },
  NZ: { code: 'NZ', name: 'New Zealand', flag: '🇳🇿' },
  NI: { code: 'NI', name: 'Nicaragua', flag: '🇳🇮' },
  NE: { code: 'NE', name: 'Niger', flag: '🇳🇪' },
  NG: { code: 'NG', name: 'Nigeria', flag: '🇳🇬' },
  MK: { code: 'MK', name: 'North Macedonia', flag: '🇲🇰' },
  NO: { code: 'NO', name: 'Norway', flag: '🇳🇴' },
  OM: { code: 'OM', name: 'Oman', flag: '🇴🇲' },
  PK: { code: 'PK', name: 'Pakistan', flag: '🇵🇰' },
  PW: { code: 'PW', name: 'Palau', flag: '🇵🇼' },
  PS: { code: 'PS', name: 'Palestine', flag: '🇵🇸' },
  PA: { code: 'PA', name: 'Panama', flag: '🇵🇦' },
  PG: { code: 'PG', name: 'Papua New Guinea', flag: '🇵🇬' },
  PY: { code: 'PY', name: 'Paraguay', flag: '🇵🇾' },
  PE: { code: 'PE', name: 'Peru', flag: '🇵🇪' },
  PH: { code: 'PH', name: 'Philippines', flag: '🇵🇭' },
  PL: { code: 'PL', name: 'Poland', flag: '🇵🇱' },
  PT: { code: 'PT', name: 'Portugal', flag: '🇵🇹' },
  QA: { code: 'QA', name: 'Qatar', flag: '🇶🇦' },
  RO: { code: 'RO', name: 'Romania', flag: '🇷🇴' },
  RU: { code: 'RU', name: 'Russia', flag: '🇷🇺' },
  RW: { code: 'RW', name: 'Rwanda', flag: '🇷🇼' },
  KN: { code: 'KN', name: 'Saint Kitts and Nevis', flag: '🇰🇳' },
  LC: { code: 'LC', name: 'Saint Lucia', flag: '🇱🇨' },
  VC: { code: 'VC', name: 'Saint Vincent and the Grenadines', flag: '🇻🇨' },
  WS: { code: 'WS', name: 'Samoa', flag: '🇼🇸' },
  SM: { code: 'SM', name: 'San Marino', flag: '🇸🇲' },
  ST: { code: 'ST', name: 'São Tomé and Príncipe', flag: '🇸🇹' },
  SA: { code: 'SA', name: 'Saudi Arabia', flag: '🇸🇦' },
  SN: { code: 'SN', name: 'Senegal', flag: '🇸🇳' },
  RS: { code: 'RS', name: 'Serbia', flag: '🇷🇸' },
  SC: { code: 'SC', name: 'Seychelles', flag: '🇸🇨' },
  SL: { code: 'SL', name: 'Sierra Leone', flag: '🇸🇱' },
  SG: { code: 'SG', name: 'Singapore', flag: '🇸🇬' },
  SK: { code: 'SK', name: 'Slovakia', flag: '🇸🇰' },
  SI: { code: 'SI', name: 'Slovenia', flag: '🇸🇮' },
  SB: { code: 'SB', name: 'Solomon Islands', flag: '🇸🇧' },
  SO: { code: 'SO', name: 'Somalia', flag: '🇸🇴' },
  ZA: { code: 'ZA', name: 'South Africa', flag: '🇿🇦' },
  SS: { code: 'SS', name: 'South Sudan', flag: '🇸🇸' },
  ES: { code: 'ES', name: 'Spain', flag: '🇪🇸' },
  LK: { code: 'LK', name: 'Sri Lanka', flag: '🇱🇰' },
  SD: { code: 'SD', name: 'Sudan', flag: '🇸🇩' },
  SR: { code: 'SR', name: 'Suriname', flag: '🇸🇷' },
  SE: { code: 'SE', name: 'Sweden', flag: '🇸🇪' },
  CH: { code: 'CH', name: 'Switzerland', flag: '🇨🇭' },
  SY: { code: 'SY', name: 'Syria', flag: '🇸🇾' },
  TW: { code: 'TW', name: 'Taiwan', flag: '🇹🇼' },
  TJ: { code: 'TJ', name: 'Tajikistan', flag: '🇹🇯' },
  TZ: { code: 'TZ', name: 'Tanzania', flag: '🇹🇿' },
  TH: { code: 'TH', name: 'Thailand', flag: '🇹🇭' },
  TL: { code: 'TL', name: 'Timor-Leste', flag: '🇹🇱' },
  TG: { code: 'TG', name: 'Togo', flag: '🇹🇬' },
  TO: { code: 'TO', name: 'Tonga', flag: '🇹🇴' },
  TT: { code: 'TT', name: 'Trinidad and Tobago', flag: '🇹🇹' },
  TN: { code: 'TN', name: 'Tunisia', flag: '🇹🇳' },
  TR: { code: 'TR', name: 'Turkey', flag: '🇹🇷' },
  TM: { code: 'TM', name: 'Turkmenistan', flag: '🇹🇲' },
  TV: { code: 'TV', name: 'Tuvalu', flag: '🇹🇻' },
  UG: { code: 'UG', name: 'Uganda', flag: '🇺🇬' },
  UA: { code: 'UA', name: 'Ukraine', flag: '🇺🇦' },
  AE: { code: 'AE', name: 'United Arab Emirates', flag: '🇦🇪' },
  GB: { code: 'GB', name: 'United Kingdom', flag: '🇬🇧' },
  US: { code: 'US', name: 'United States', flag: '🇺🇸' },
  UY: { code: 'UY', name: 'Uruguay', flag: '🇺🇾' },
  UZ: { code: 'UZ', name: 'Uzbekistan', flag: '🇺🇿' },
  VU: { code: 'VU', name: 'Vanuatu', flag: '🇻🇺' },
  VA: { code: 'VA', name: 'Vatican City', flag: '🇻🇦' },
  VE: { code: 'VE', name: 'Venezuela', flag: '🇻🇪' },
  VN: { code: 'VN', name: 'Vietnam', flag: '🇻🇳' },
  YE: { code: 'YE', name: 'Yemen', flag: '🇾🇪' },
  ZM: { code: 'ZM', name: 'Zambia', flag: '🇿🇲' },
  ZW: { code: 'ZW', name: 'Zimbabwe', flag: '🇿🇼' }
};

// Convert to array format sorted alphabetically by name
export const WORLD_COUNTRIES_ARRAY = Object.values(WORLD_COUNTRIES).sort((a, b) => 
  a.name.localeCompare(b.name)
);

// Helper function to get country data by code
export const getWorldCountryData = (countryCode) => {
  return WORLD_COUNTRIES[countryCode] || null;
};

// Helper function to search countries by name
export const searchCountries = (searchTerm) => {
  const term = searchTerm.toLowerCase();
  return WORLD_COUNTRIES_ARRAY.filter(country => 
    country.name.toLowerCase().includes(term) || 
    country.code.toLowerCase().includes(term)
  );
};